import { render } from "./formularioContratante.vue?vue&type=template&id=f213a44c"
import script from "./formularioContratante.vue?vue&type=script&lang=js"
export * from "./formularioContratante.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__